export const APIHOST = 'https://jdapi.jd100.com';
// export const APIHOST = 'http://192.168.4.157:9003';
export const VIPHOST = 'https://vip.jd100.com'; // 简单学习网 域名
export const REPORTHOST = 'https://st.jd100.com/st/'; // 数据埋点

export const subjectCode = {
  '全部': 0,
  '语文': 1,
  '数学': 2,
  '英语': 3,
  '物理': 4,
  '化学': 5,
  '生物': 6,
  '历史': 7,
  '地理': 8,
  '政治': 9,
  '文科综合': 10,
  '理科综合': 11,
  '其他': 12,
  '科学': 13,
  '综合': 14
}

export const ALLOPTIONS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'];
export const subjectList = ['数学', '语文', '英语', '物理', '化学', '生物', '地理', '历史', '政治', '科学', '综合']
